import React from 'react';

import { IconProps } from './type';

const PlusIcon: React.FC<IconProps> = ({ className = '', size = 24 }) => {
  return (
    <svg width={size} viewBox="0 0 24 24" fill="none" className={className}>
      <path
        d="M12 5V19M5 12H19"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PlusIcon;
